/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IConfigurationModel } from "@nf/common";
import React from "react";
import dynamic from "next/dynamic";
import cx from "classnames";

import { AppHeader, type NavConfig } from "../../components";
import { LayoutSection } from "components/LayoutSection/LayoutSection";

import styles from "./Layout.module.scss";

const AppFooter = dynamic(() => import("../../components/AppFooter"), {
  ssr: false,
});

export interface LayoutProps {
  children: React.ReactNode;
  className?: string;
  config?: IConfigurationModel;
  header?: boolean;
  footer?: boolean;
  navigation?: NavConfig;
}

const Layout = ({
  children,
  className,
  header = true,
  footer = true,
  config,
  navigation,
}: LayoutProps) => {
  return (
    <div className={cx(styles.container, className)}>
      {config && header ? (
        <AppHeader configuration={config} navigation={navigation} />
      ) : null}
      <LayoutSection>{children}</LayoutSection>
      {config && footer ? <AppFooter configuration={config} /> : null}
    </div>
  );
};

export default Layout;
